import { Dispatch, SetStateAction } from 'react';
import { mapToSubAccountType, maskAccountNumber } from '../../domain/services/BankAccountModifierService';
import { IAccount } from '../../containers/tuSuccessPage/utils';
import FeatherIcon from 'feather-icons-react';

const TuAccountsTile = ({
  tuAccount,
  onBankConnect,
  setIsAccountsModalOpen,
  connectedAccountsForBrand = 0,
  setSelectedAccountToConnect,
  showChevron = true
}: {
  tuAccount: IAccount;
  showChevron?: boolean;
  onBankConnect: () => void;
  connectedAccountsForBrand?: number;
  setIsAccountsModalOpen?: Dispatch<SetStateAction<boolean>>;
  setSelectedAccountToConnect?: Dispatch<SetStateAction<IAccount | undefined>>;
}) => {
  if (!tuAccount) return null;
  return (
    <div
      data-testid={tuAccount.accountIdentifiers?.find(a => a.value != null)?.value}
      className="min-h-12 w-full rounded-lg"
    >
      <div className="rounded-lg mt-2 flex flex-col gap-4">
        <div className="flex pb-2 items-center justify-between border-b border-gray-400">
          <div>
            {tuAccount.accountSubType && (
              <p className="p-0! m-0! capitalize text-gray-800 text-base">
                {mapToSubAccountType(tuAccount.accountSubType as ReturnType<keyof typeof mapToSubAccountType>)}
              </p>
            )}
            <span className="text-gray-500 text-base font-medium">
              {maskAccountNumber(tuAccount.accountIdentifiers?.find(a => a.value != null)?.value)}
            </span>
          </div>
          {tuAccount?.connected ? (
            <div className="border-primary-1 border-3 rounded-full w-9 h-9 flex items-center justify-center">
              <FeatherIcon icon="check" size={28} strokeWidth={2} className="text-primary-1" />
            </div>
          ) : (
            showChevron && (
              <div
                data-testid="account-connect-btn"
                onClick={() => {
                  if (connectedAccountsForBrand > 0) {
                    setIsAccountsModalOpen?.(true);
                    setSelectedAccountToConnect?.(tuAccount);
                  } else {
                    onBankConnect();
                  }
                }}
                className="bg-primary-2 rounded-full w-9 h-9 flex items-center justify-center cursor-pointer"
              >
                <FeatherIcon icon="chevron-right" className="text-white" size={32} />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default TuAccountsTile;
